<template>
    <div :id="this.id" :class="['flex w-full', this.classList]" data-inc="GDC - Filters">
        <autocomplete
            class-list="order-2 lg:order-none"
            :suggestions="this.filteredArticles"
            v-model="searchTerm"
            :placeholder="searchPlaceholderText"
        ></autocomplete>

        <!-- mobile toggle -->
        <button class="w-full p-1 mb-2 mt-2 rounded border border-gdc-gray-900
                           text-sm font-semibold inline-flex order-1 justify-center lg:hidden"
                @click="isActive = true;">
            <img class="lazyload" :data-src="filterIcon" width="22" height="22" alt="Filter Articles"/>
            <span class="pl-2">{{ filterLabelText.toUpperCase() }} </span>
            <span>({{ activeFilters.length }})</span>
        </button>

        <ActiveFilters :activeFilters="activeFilters" @activeFiltersEvent="activeFiltersListener"/>

        <!-- mobile header -->
        <div :class="[
                'p-4 border-b w-full flex justify-between fixed left-0 top-0 z-[2001]',
                'bg-gdc-gray-100 text-sm text-gdc-red-600', {
                'hidden': !isActive
            }]">
            <div class="inline-flex">
                <img class="lazyload" :data-src="filterIcon" width="22" height="22" alt="Filter Articles"/>
                <span class="pl-2 text-black">{{ filterLabelText.toUpperCase() }} </span>
            </div>
            <div class="inline-flex" @click="isActive = false">
                {{ closeLabelText }}
                <svg class="ml-1 closeTooltip" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="24" height="24" preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50"><path d="M37.304 11.282l1.414 1.414l-26.022 26.02l-1.414-1.413z" fill="#d23b42" /><path d="M12.696 11.282l26.022 26.02l-1.414 1.415l-26.022-26.02z" fill="#d23b42" /></svg>
            </div>
        </div>

        <div :class="['w-full bg-white lg:block', {
                'fixed p-4 pt-20 z-[2000] h-vh top-0 left-0 right-0 bottom-0 overflow-y-auto': isActive,
                'hidden': !isActive
            }]">
            <FilterGroup v-for="filter in filters" :key="filter.id" v-bind:filter="filter" @filtersListenerEvent="filtersListener"/>

            <FilterSubmit :activeFilters="activeFilters"
                          :isActive="isActive"
                          @activeFiltersEvent="activeFiltersListener"
                          @saveFilters="saveFilters" />
        </div>
    </div>
</template>


<script>

import autocomplete from "../../Forms/Autocomplete"
import FilterGroup from "./FilterGroup";
import ActiveFilters from "./ActiveFilters";
import FilterSubmit from "./FilterSubmit";

export default {

    name: "filters",

    components: {
        autocomplete,
        ActiveFilters,
        FilterGroup,
        FilterSubmit
    },

    props: {

        id: {
            type: String
        },

        classList: {
            type: String
        },

        initialFilters: {
            type: Array
        },

        articles: {
            type: Array
        },

        filterIcon: {
            type: String
        },
    },
    data() {
        return {
            filters: this.initialFilters,
            searchTerm: '',
            isActive: false,
        };
    },

    /**
     * TODO: maybe move translation functions outside in there own files
     */
    computed: {

        /**
         * Placeholder Text
         * @return {*|string}
         */
        searchPlaceholderText()
        {
            return window.translations?.siteArticleStrategyFilter?.search_placeholder || 'Search articles...';
        },

        /**
         * Filter Label Text
         * @return {*|string}
         */
        filterLabelText()
        {
            return window.translations?.slotGameFilters?.filter_label || 'Filter';
        },

        /**
         * Close Label Text
         * @return {*|string}
         */
        closeLabelText()
        {
            return window.translations?.slotGameFilters?.close_label || 'Close';
        },


        /**
         * Get All the filters that have the is_active flag set to true
         *
         * @return {*}
         */
        activeFilters()
        {
            return this.filters.map((filter) => filter.attributes.filter((attr) => attr.is_active)).flat();
        },

        /**
         * Filtered Articles
         *
         * @return {*[]}
         */
        filteredArticles()
        {
            return this.articles.filter((article) => {
                let active = [];

                active = this.activeFilters.map((filter) => {
                    // filter.attribute_type_id is either product_type_id or product_faeture_id
                    // check the article to see if the value of the id exist
                    if (article[filter.attribute_type_id].includes(filter.attribute_value)) {
                        return true;
                    }
                    return false;
                });

                // We could have multiple filters selected
                // An article that matches any 1 filter is true here
                let hasFilters = active.includes(true);

                let hasSearch =
                    this.searchTerm === ''
                        ? true
                        : article.title.toLowerCase().includes(this.searchTerm.toLowerCase());

                // If we have a filter selected, the article must match both the filter and searchTerm
                if (this.activeFilters.length > 0) {
                    return hasFilters && hasSearch;
                } else {
                    // If we don't have a filter selected, the article can match either or
                    return hasFilters || hasSearch;
                }
            });
        },
    },

    methods: {


        activeFiltersListener()
        {
            this.$emit('input', this.filteredArticles);
        },

        filtersListener()
        {
            this.$emit('input', this.filteredArticles);
        },

        saveFilters()
        {
            this.isActive = !this.isActive;
        },


        // This function would disable filters that are not used by any articles
        // It is from the slot games filter, has been modified to work with articles
        // However, not sure if this behavior is needed so commented out the usage for now.
        disableFilters()
        {
            this.filters = this.filters.map((filter) =>
            {
                filter.attributes.forEach((attr) => {
                    attr.is_disabled = this.filteredArticles.every((article) =>
                    {
                        if (!article[attr.attribute_type_id].includes(attr.attribute_value))
                        {
                            return true;
                        }
                        return false;
                    });
                });

                return filter;
            });
        },

    },

    watch: {

        /**
         * when the prop data changed populate the two-way binding data
         * @param value
         */
        initialFilters(value)
        {
            this.filters = value;
        },

        /**
         * when the search term changed emit event
         */
        searchTerm()
        {
            this.$emit('input', this.filteredArticles);
        },
    },
};
</script>
